import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-view-documents',
  templateUrl: './icon-view-documents.component.html',
  styleUrls: ['./icon-view-documents.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconViewDocumentsComponent {}
